var dealerData = [
 {
   "Name": "Ace Bicycles",
   "X": -0.5480077,
   "Y": 51.2579257,
   "Website": "http://www.acebicycles.co.uk/",
   "Address": "218 London Rd, Guildford GU4 7JS",
   "Phone": "01483302210",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": false,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Lap Bikes",
   "X": -0.1021996,
   "Y": 51.5181993,
   "Website": "http://www.lapbikes.com/",
   "Address": "47 Little Britain, London EC1A 7BH",
   "Phone": "02045860081",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": false,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
  {
   "Name": "Pedal Syndicate",
   "X": -2.5721696,
   "Y": 51.8091649,
   "Website": "http://www.pedalsyndicate.co.uk/",
   "Address": "Centre, Forest of Dean Cycle, Coleford GL16 7EH",
   "Phone": "01600715071",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": false,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
  {
   "Name": "RM Cycles",
   "X": 0.4289815,
   "Y": 51.0489073,
   "Website": "http://www.rmcycles.co.uk/",
   "Address": "Unit 3A, Leigh Green Industrial Estate, Appledore Rd, Tenterden TN30 7DE",
   "Phone": "01580765612",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": false,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
  {
   "Name": "Activ Cycles Ashford",
   "X": -3.5626346,
   "Y": 52.8703803,
   "Website": "http://www.activcycles.co.uk/",
   "Address": "Units 1 & 2, Kingfisher Business Park, Henwood, Ashford TN24 8DG",
   "Phone": "01233424002",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
  {
   "Name": "Big Bear Bikes",
   "X": -0.7831092,
   "Y": 54.2449092,
   "Website": "https://www.bigbearbikes.co.uk/",
   "Address": "The Co-Op Building 2, Southgate, Pickering YO18 8BL",
   "Phone": "01751474220",
   "OfficialDemo": true,
   "SCB": true,
   "Juliana": false,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
  {
   "Name": "True North Cycle Hub",
   "X": -1.5682196,
   "Y": 53.4783965,
   "Website": "http://www.truenorthcyclehub.co.uk/",
   "Address": "Step Business Centre, Wortley Rd, Deepcar, Sheffield S36 2UH",
   "Phone": "01146989609",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": false,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
  {
   "Name": "Clarkes of Cavan",
   "X": -7.3541042,
   "Y": 53.9744542,
   "Website": "https://booking.clarkesofcavan.ie/cycle-centre/",
   "Address": "Moynehall Retail Park, Ballinagh Road, Cavan, H12 Y7H1, Ireland",
   "Phone": "+353494332166",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "MTB Monster",
   "X": -2.532781,
   "Y": 53.7843406,
   "Website": "https://www.mtbmonster.com/contact-us-information/",
   "Address": "Fairfield Business Park, 4A, Longsight Rd, Blackburn BB2 7JA",
   "Phone": "01254 959345",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
  {
   "Name": "Leisure Lakes Bikes - Lancaster",
   "X": -2.8015285,
   "Y": 54.0452744,
   "Website": "http://www.leisurelakesbikes.com/",
   "Address": "103-105 Penny St, Lancaster, LA1 1XN",
   "Phone": "01523 844839",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "18 Bikes",
   "X": -1.743308,
   "Y": 53.348316,
   "Website": "https://www.18bikes.co.uk/",
   "Address": "3, 8 Castleton Rd, Hope, Hope Valley S33 6RD",
   "Phone": "01433 621111",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": false,
   "SweetProtection": true,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Aarons Bikes",
   "X": -2.1112936,
   "Y": 49.1872224,
   "Website": "http://www.aaronsbikes.com/",
   "Address": "5 Gloucester St, St Helier, Jersey JE2 3QR, Jersey",
   "Phone": "01534 280989",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": false,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "AE Bike Shop & Cafe",
   "X": -3.59623,
   "Y": 55.1887295,
   "Website": "http://www.aebikeshopandcafe.co.uk/",
   "Address": "Ae Village, Dumfries DG1 1QB",
   "Phone": "01387 860805",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": false,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "The Afan Valley Bike Shed",
   "X": -3.7055772,
   "Y": 51.6419468,
   "Website": "http://www.afanvalleybikeshed.co.uk/",
   "Address": "Afan Argoed Countryside Centre, Cynonville SA13 3HG",
   "Phone": "01639 851406",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "The Bike Place in Kielder Ltd",
   "X": -2.5804299,
   "Y": 55.2351962,
   "Website": "https://www.thebikeplace.co.uk/kielder-cycle-centre",
   "Address": "Kielder Cycle Centre, Kielder, Hexham NE48 1ER",
   "Phone": "01434 250457",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": true,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Biketart",
   "X": 1.1458297,
   "Y": 51.1861632,
   "Website": "http://www.biketart.com/",
   "Address": "Unit 19, Barham Business Park, Canterbury CT4 6DQ",
   "Phone": "01227 832582",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": false,
   "SweetProtection": true,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Bikegoo",
   "X": 0.1895853,
   "Y": 51.0471912,
   "Website": "http://www.bikegoo.co.uk/",
   "Address": "1, Lexden Lodge Industrial Estate, Crowborough Hill, Crowborough TN6 2NQ",
   "Phone": "01892 668800",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": false,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Peddlers Cycles",
   "X": -1.0885301,
   "Y": 54.617034,
   "Website": "http://www.peddlers-cycles.co.uk/",
   "Address": "16 York Rd, Redcar TS10 5AA",
   "Phone": "01642490135",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": false,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Biketreks Grizedale",
   "X": -3.0243086,
   "Y": 54.3411632,
   "Website": "http://www.bike-treks.co.uk/",
   "Address": "Grizedale, Forest, Ambleside LA22 0QJ",
   "Phone": "015394 31245",
   "OfficialDemo": true,
   "SCB": true,
   "Juliana": true,
   "Reserve": true,
   "SweetProtection": true,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "BRINK",
   "X": -0.397221,
   "Y": 52.073731,
   "Website": "https://brink.uk/",
   "Address": "Summerfield Barn, Hammerhill, Bedford MK45 3BH",
   "Phone": "01462 600111",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "BW Cycling",
   "X": -2.6229839,
   "Y": 51.4478797,
   "Website": "https://bwcycling.co.uk/",
   "Address": "Unit 1-2, Brunel Lock Development, Smeaton Rd, Bristol BS1 6SE",
   "Phone": "0117 927 2947",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },

 {
   "Name": "Cadence",
   "X": -2.3890108,
   "Y": 51.3858445,
   "Website": "http://www.cadencebikeshop.com/",
   "Address": "9 Chelsea Rd, Bath BA1 3PP",
   "Phone": "01225 446887",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": false,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Cannock Chase Cycle Centre",
   "X": -1.972537,
   "Y": 52.7513379,
   "Website": "http://www.bikechase.co.uk/",
   "Address": "Cannock Chase Cycle Centre, Birches Valley, Lady Hill, Rugeley WS15 2UQ",
   "Phone": "01889 575170",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Country Cycles",
   "X": -4.3724212,
   "Y": 56.0437183,
   "Website": "http://www.country-cycles.com/",
   "Address": "2 Main St, Killearn, Glasgow G63 9NH",
   "Phone": "01360 551129",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": false,
   "SweetProtection": true,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Cycle Highlands",
   "X": -3.0402832,
   "Y": 57.0480444,
   "Website": "http://www.cyclehighlands.com/",
   "Address": "The Pavilion, Victoria Road, Ballater AB35 5QQ",
   "Phone": "01339 755864",
   "OfficialDemo": true,
   "SCB": true,
   "Juliana": true,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Dirt Works Bikes",
   "X": -2.346171,
   "Y": 52.1123927,
   "Website": "https://dirtworks.co.uk/",
   "Address": "193 W Malvern Rd, Malvern WR14 4BB",
   "Phone": "01684 212278",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Don Skene Cycles Ltd",
   "X": -3.1320974,
   "Y": 51.509007,
   "Website": "http://www.teamskene.com/",
   "Address": "769 Newport Rd, Rumney, Cardiff CF3 4AJ",
   "Phone": "029 2077 7158",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Elevation Cycles",
   "X": -3.601825,
   "Y": 55.9765397,
   "Website": "https://www.elevationcycles.co.uk/",
   "Address": "103 High St, Linlithgow EH49 7EQ",
   "Phone": "01506845390",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Escape Bike Shop",
   "X": -2.5120463,
   "Y": 54.1634254,
   "Website": "http://www.escapebikeshop.com/",
   "Address": "Kirksteads, Westhouse, Ingleton, Lancaster LA6 3NJ",
   "Phone": "01524241226",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": false,
   "SweetProtection": true,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Evolution Cycles",
   "X": 0.26778,
   "Y": 50.756603,
   "Website": "http://www.evocycles.co.uk/",
   "Address": "24 Meads St, Eastbourne BN20 7QY",
   "Phone": "01323737320",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": false,
   "SweetProtection": true,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "The Iron Horse Cyclery",
   "X": -1.5570447,
   "Y": 54.5245761,
   "Website": "http://www.ironhorsecyclery.com/",
   "Address": "10 Clark's Yard, Darlington DL3 7QH",
   "Phone": "01325 284500",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": false,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Leisure Lakes Bikes Nottingham",
   "X": -1.3035209,
   "Y": 52.8979318,
   "Website": "http://www.leisurelakesbikes.com/",
   "Address": "168 Wilsthorpe Rd, Breaston, Derby DE72 3AG",
   "Phone": "01332 872947",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Leisure Lakes Bikes Bury",
   "X": -2.2855507,
   "Y": 53.5926076,
   "Website": "http://www.leisurelakesbikes.com/",
   "Address": "124 Rochdale Rd, Bury BL9 7AY",
   "Phone": "0161 7975625",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Leisure Lakes Bikes Cheltenham",
   "X": -2.0733492,
   "Y": 51.9014557,
   "Website": "http://www.leisurelakesbikes.com/",
   "Address": "27 Pittville St, Cheltenham GL52 2LN",
   "Phone": "01242 251505",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Leisure Lakes Bikes Daventry",
   "X": -1.1576199,
   "Y": 52.2605667,
   "Website": "http://www.leisurelakesbikes.com/",
   "Address": "Abbey Retail Park, South Way, Daventry NN11 4GL",
   "Phone": "01327 317 158",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Leisure Lakes Bikes Preston/Southport",
   "X": -2.8950943,
   "Y": 53.6543151,
   "Website": "http://www.leisurelakesbikes.com/",
   "Address": "The Gravel, Mere Brow, Tarleton, Preston PR4 6JX",
   "Phone": "01772 814990",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Mech Monkey",
   "X": -5.9625266,
   "Y": 54.5740716,
   "Website": "http://mechmonkey.co.uk/",
   "Address": "2a Balmoral Link, Belfast BT12 6QB",
   "Phone": "0289 5433921",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Northwest Mountain Bike Centre",
   "X": -2.2013959,
   "Y": 53.3974153,
   "Website": "https://www.northwestcycles.net/",
   "Address": "249 Stockport Rd, Cheadle, Manchester SK8 2BS",
   "Phone": "0161 4283311",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": true,
   "SweetProtection": true,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "One Planet Adventure",
   "X": -3.1357835,
   "Y": 53.0626628,
   "Website": "http://www.oneplanetadventure.com/",
   "Address": "Coed Llandegla Forest, Ruthin Rd, Llandegla, Wrexham LL11 3AA",
   "Phone": "01978 751656",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": false,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Republic of Bike",
   "X": -6.1110582,
   "Y": 53.2021315,
   "Website": "http://www.republicofbike.ie/",
   "Address": "St Kevin's Square, Bray, Co. Wicklow, A98 W899, Ireland",
   "Phone": "087 782 9793",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": true,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Ride Scotland",
   "X": -3.7524443,
   "Y": 57.2486979,
   "Website": "http://www.ridescotland.com/",
   "Address": "Ride Railway Station, Boat of Garten PH24 3BH",
   "Phone": "01479 831729",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": false,
   "SweetProtection": true,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Rockets and Rascals",
   "X": -1.945882,
   "Y": 50.7083548,
   "Website": "https://rocketsandrascalspoole.com/",
   "Address": "278 Sandbanks Rd, Lilliput, Poole BH14 8HU",
   "Phone": "01202 708842",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": false,
   "Reserve": true,
   "SweetProtection": true,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Rockin Bikes",
   "X": -4.0915026,
   "Y": 50.4928929,
   "Website": "http://www.rockinbikes.co.uk/",
   "Address": "7-8, Harrowbeer Mews, Yelverton PL20 6WE",
   "Phone": "01822 258022",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Rutland Cycling Whitwell",
   "X": -0.6362719,
   "Y": 52.6651166,
   "Website": "https://www.rutlandcycling.com/pages/rutland-cycling-whitwell.aspx",
   "Address": "Whitwell Leisure Park, Bull Brig Ln, Oakham LE15 8BL",
   "Phone": "01780 460 705",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Spokes Bikeshop",
   "X": -2.2672595,
   "Y": 53.0149799,
   "Website": "http://www.spokesbikeshop.co.uk/",
   "Address": "61-63 High St, Silverdale, Stoke-on-Trent, Newcastle ST5 6LY",
   "Phone": "01782 937786",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": false,
   "SweetProtection": true,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Sprockets Cycles",
   "X": -4.510859,
   "Y": 55.5835663,
   "Website": "https://www.sprocketscycles.com/",
   "Address": "Ayr Rd, Kilmarnock KA1 5LF",
   "Phone": "01563 526800",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Start Fitness",
   "X": -1.6140238,
   "Y": 54.9724724,
   "Website": "http://www.startfitness.co.uk/",
   "Address": "33-35 Market St, Newcastle upon Tyne NE1 6JE",
   "Phone": "0191 255 0801",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Summit Cycles",
   "X": -4.0806786,
   "Y": 52.4159451,
   "Website": "http://www.summitcycles.co.uk/",
   "Address": "65 N Parade, Aberystwyth SY23 2JN",
   "Phone": "01970 626061",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": false,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "The BikeShed",
   "X": -3.5338649,
   "Y": 50.7218328,
   "Website": "http://www.bikesheduk.com/",
   "Address": "163 Fore St, Exeter EX4 3AT",
   "Phone": "01392 426191",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": false,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "The Breakpad bike shop",
   "X": -4.4193948,
   "Y": 54.9545059,
   "Website": "http://www.thebreakpad.com/",
   "Address": "Newton Stewart DG8 7BE",
   "Phone": "01671 401303",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "The Trailhead Bicycle Company",
   "X": -2.760024,
   "Y": 52.711247,
   "Website": "http://www.thetrailhead.co.uk/",
   "Address": "20 Frankwell, Shrewsbury SY3 8JY",
   "Phone": "01743 537124",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": true,
   "SweetProtection": true,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Tweed Valley Bikes",
   "X": -3.0641614,
   "Y": 55.6189496,
   "Website": "http://tweedvalleybikes.co.uk/",
   "Address": "60 High St, Innerleithen EH44 6HF",
   "Phone": "01896 831429",
   "OfficialDemo": true,
   "SCB": true,
   "Juliana": true,
   "Reserve": false,
   "SweetProtection": true,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Twelve50 Bikes",
   "X": -2.7261978,
   "Y": 53.295534,
   "Website": "http://www.twelve50bikes.com/",
   "Address": "102 Main St, Frodsham WA6 7AR",
   "Phone": "01928 898 011",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Two Wheels",
   "X": -2.153805,
   "Y": 52.470681,
   "Website": "https://www.twowheelscycles.com/",
   "Address": "113 Brettell Ln, Amblecote, Stourbridge DY8 4BS",
   "Phone": "01384 394653",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Billy Bilsland Cycles",
   "X": -4.2461725,
   "Y": 55.8544043,
   "Website": "https://www.billybilslandcycles.co.uk/",
   "Address": "176 Saltmarket, Glasgow G1 5LA",
   "Phone": "0141 552 0841",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Blazing Saddles of Hebden Bridge",
   "X": -2.014613,
   "Y": 53.74112,
   "Website": "http://blazingsaddles.co.uk/",
   "Address": "35 W End, Hebden Bridge HX7 8UQ",
   "Phone": "01422 844435",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Picton Cycles",
   "X": -2.921679,
   "Y": 53.3990649,
   "Website": "http://www.pictoncycles.co.uk/",
   "Address": "11-13 High St, Wavertree, Liverpool L15 8HE",
   "Phone": "0151 733 5507",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": true,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Alf Jones Cycles",
   "X": -2.9670539,
   "Y": 53.0864317,
   "Website": "http://www.alfjonescycles.co.uk/",
   "Address": "82 Chester Rd, Gresford, Wrexham LL12 8NT",
   "Phone": "01978 854 300",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": true,
   "Reserve": true,
   "SweetProtection": true,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Backyard Bike Shop",
   "X": -1.605514,
   "Y": 54.9673654,
   "Website": "http://www.backyardbikeshop.com/",
   "Address": "Hillgate Quay, Gateshead NE8 2BH",
   "Phone": "07519 098963",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": true,
   "Cervelo": false,
   "CerveloDirt": false
 },
 {
   "Name": "Bicycle Repair Man Ltd",
   "X": -1.8425996,
   "Y": 54.9689847,
   "Website": "https://www.cervelo.com/en-GB/store-locator#",
   "Address": "6B Earls Ct, Prudhoe NE42 6QG",
   "Phone": "01661 853 603",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Wheelbase North East Darlington",
   "X": -1.5585107,
   "Y": 54.5263521,
   "Website": "https://wheelbase.co.uk/",
   "Address": "100 Bondgate, Darlington DL3 7LB",
   "Phone": "01325 352 255",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "NRG Cycles LTD",
   "X": -1.141788,
   "Y": 54.489144,
   "Website": "https://www.nrgcycles.co.uk/",
   "Address": "39 High St, Great Ayton, Middlesbrough TS9 6NH",
   "Phone": "01642 723 527",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Prologue Performance Cycling",
   "X": -1.5511352,
   "Y": 53.9915451,
   "Website": "http://www.prologuecycling.co.uk/",
   "Address": "Wellington House, Cold Bath Rd, Harrogate HG2 0NA",
   "Phone": "01423 503 000",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "WHEELBASE Ilkley",
   "X": -1.8308095,
   "Y": 53.9261037,
   "Website": "http://www.wheelbase.co.uk/",
   "Address": "25 Skipton Rd, Ilkley LS29 9EW",
   "Phone": "01943 816 101",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Northern Ride",
   "X": -0.800357,
   "Y": 54.135383,
   "Website": "https://www.northernride.com/Default.asp",
   "Address": "19 Saville St, Malton YO17 7LL",
   "Phone": "01653 699 070",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "J's Cycle Shack",
   "X": -1.2733828,
   "Y": 53.7137234,
   "Website": "http://www.jscycleshack.com/",
   "Address": "4 Old Great N Rd, Ferrybridge, Knottingley WF11 8PH",
   "Phone": "01977 679 998",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Bill Nickson Cycles",
   "X": -2.7000182,
   "Y": 53.6906543,
   "Website": "http://www.billnicksoncycles.com/",
   "Address": "57-61 Towngate, Leyland PR25 2FQ",
   "Phone": "01772422259",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Ace Bike Co",
   "X": -3.0602947,
   "Y": 55.9442075,
   "Website": "http://www.acebikeco.com/",
   "Address": "101 N High St, Musselburgh EH21 6JE",
   "Phone": "01316 654 468",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "PEAK cyclesport",
   "X": -2.1292765,
   "Y": 53.2605428,
   "Website": "http://www.peakcyclesport.com/",
   "Address": "Grosvenor Centre, Macclesfield SK11 6AR",
   "Phone": "01625 426 333",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "The Bicycle Lounge",
   "X": -2.8855958,
   "Y": 53.5667267,
   "Website": "http://www.thebicyclelounge.co.uk/",
   "Address": "46-48 Moor St, Ormskirk L39 2AQ",
   "Phone": "01695 577 240",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Spokes Cycles",
   "X": -2.9948249,
   "Y": 56.459506,
   "Website": "http://www.spokescycles.net/",
   "Address": "8 Annfield Rd, Dundee DD1 5JH",
   "Phone": "01382 666 644",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Bike Station",
   "X": -3.0432831,
   "Y": 57.0500595,
   "Website": "http://www.bikestationballater.co.uk/",
   "Address": "Station Square, Ballater AB35 5RB",
   "Phone": "07552 169 272",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Cliff Pratt Cycles",
   "X": -0.3524692,
   "Y": 53.7491524,
   "Website": "http://www.cpcycles.com/",
   "Address": "61 Spring Bank, Hull HU3 1AG",
   "Phone": "01482 228 293",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Pedal Power",
   "X": -3.5743922,
   "Y": 55.8512996,
   "Website": "https://www.pedalpower.org.uk/",
   "Address": "13 Main St, West Calder EH55 8BY",
   "Phone": "01506 873 123",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Peak Riders & Striders",
   "X": -2.1994647,
   "Y": 52.9607368,
   "Website": "https://ridersandstriders.com/",
   "Address": "Trentham Shopping Village, Stone Rd, Stoke-on-Trent ST4 8AX",
   "Phone": "01782 644 861",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Total Endurance",
   "X": -2.1994647,
   "Y": 52.9607368,
   "Website": "http://www.total-endurance.co.uk/",
   "Address": "4 Old Meldrum Rd, Bucksburn, Aberdeen AB21 9DT",
   "Phone": "01224 900 500",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Total Endurance",
   "X": -2.1994647,
   "Y": 52.9607368,
   "Website": "http://www.total-endurance.co.uk/",
   "Address": "4 Old Meldrum Rd, Bucksburn, Aberdeen AB21 9DT",
   "Phone": "01224 900 500",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Velocity 44",
   "X": -3.9404377,
   "Y": 56.120662,
   "Website": "http://www.velocity44.com/",
   "Address": "44 Barnton St, Stirling FK8 1NA",
   "Phone": "01786 465 292",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Pedal Pushers",
   "X": -0.6369194,
   "Y": 52.9046146,
   "Website": "https://pedalpushersbikeshop.co.uk/",
   "Address": "unit 4, 4 Inner St, Grantham NG31 6HN",
   "Phone": "01476 569 508",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Dave Mellor Cycles",
   "X": -2.7627873,
   "Y": 52.7112047,
   "Website": "http://www.davemellorcycles.com/",
   "Address": "9 New St, Frankwell, Shrewsbury SY3 8JN",
   "Phone": "01743 366 662",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "We Cycle",
   "X": -3.8020923,
   "Y": 53.282692,
   "Website": "https://www.wecycle.co.uk/",
   "Address": "Conway Rd, Llandudno Junction LL31 9BA",
   "Phone": "01492 593 811",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
  {
   "Name": "Essex Bicycles",
   "X": 0.5016813,
   "Y": 51.5641187,
   "Website": "http://essexbicycles.com/",
   "Address": "30 Station Ln, Pitsea, Basildon SS13 3BG",
   "Phone": "01268552484",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": true,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },

 {
   "Name": "Lutterworth Cycle Centre",
   "X": -1.2037776,
   "Y": 52.4558476,
   "Website": "https://lutterworthcyclecentre.co.uk/",
   "Address": "2 George St, Lutterworth LE17 4EF",
   "Phone": "01455 559 309",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Dooleys Cycles",
   "X": -4.4265391,
   "Y": 55.8421213,
   "Website": "https://www.cervelo.com/en-GB/store-locator#",
   "Address": "58 Causeyside St, Paisley PA1 1YW",
   "Phone": "01418 896 090",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Sprockets Cycles",
   "X": -4.5130477,
   "Y": 55.5835693,
   "Website": "https://www.sprocketscycles.com/",
   "Address": "Ayr Rd, Kilmarnock KA1 5LF",
   "Phone": "01563 526 800",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Bikestyle",
   "X": -4.4811768,
   "Y": 54.1480569,
   "Website": "https://www.bikestyle.im/",
   "Address": "Market Hall, Market Hill, Douglas, Isle of Man IM1 2BQ, Isle of Man",
   "Phone": "01624 673 576",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Gorilla Firm Cycling",
   "X": -0.4665909,
   "Y": 52.4866822,
   "Website": "http://www.gorillafirmcycling.com/",
   "Address": "Unit 2, Oundle Wharf, Station Rd, Peterborough PE8 4DE",
   "Phone": "01832 273 783",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Lucky 13 Bikes",
   "X": -2.0894129,
   "Y": 51.8947022,
   "Website": "https://www.lucky13bikes.co.uk/",
   "Address": "18a Lansdown Pl Ln, Cheltenham GL50 2LB",
   "Phone": "07305 049 113",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },

 {
   "Name": "PRIMO Cycles",
   "X": 0.1174943,
   "Y": 52.2080793,
   "Website": "https://www.primocycles.co.uk/",
   "Address": "5-7 Jesus Ln, Cambridge CB5 8BA",
   "Phone": "01223 500 502",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Henley Cycles Limited",
   "X": -0.9066944,
   "Y": 51.5368185,
   "Website": "http://www.henley-cycles.co.uk/",
   "Address": "16 Duke St, Henley-on-Thames RG9 1UP",
   "Phone": "01491 412 500",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Total Fitness Bath",
   "X": -2.3622072,
   "Y": 51.3845661,
   "Website": "https://www.totalfitnessbath.co.uk/",
   "Address": "3 Saracen St, Bath BA1 5BR",
   "Phone": "01225 444 164",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Aberaeron Cycle Works",
   "X": -4.2608663,
   "Y": 52.2423552,
   "Website": "http://www.aberaeroncycleworks.co.uk/",
   "Address": "London House, 1 Bridge St, Aberaeron SA46 0AP",
   "Phone": "01545 571 454",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },

 {
   "Name": "Dryburgh Cycles",
   "X": -4.4297218,
   "Y": 57.5959475,
   "Website": "http://www.dryburghcycles.co.uk/",
   "Address": "9 Tulloch St, Dingwall IV15 9JY",
   "Phone": "01349 862 163",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "The Bike Company Windsor",
   "X": -0.6141478,
   "Y": 51.4779726,
   "Website": "http://www.thebikecompany.co.uk/",
   "Address": "Trinity Yard, 59 St. Leonards Rd, Windsor SL4 3BX",
   "Phone": "01753 751 007",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Tredz Bikes | Swansea",
   "X": -3.9110128,
   "Y": 51.6568955,
   "Website": "https://www.tredz.co.uk/help-advice/customer-service/stores/tredz-swansea",
   "Address": "Castell Close, Swansea Enterprise Park, Llansamlet, Swansea SA7 9FH",
   "Phone": "01792 702 555",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Bike & Run",
   "X": -0.1663007,
   "Y": 51.5907309,
   "Website": "http://www.bikeandrun.co.uk/",
   "Address": "128 High Rd, London N2 9ED",
   "Phone": "02088 151 845",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Strype Street Cycles",
   "X": -0.0787728,
   "Y": 51.5172575,
   "Website": "https://www.strypestreetcycles.co.uk/",
   "Address": "8 Strype St, London E1 7LF",
   "Phone": "02073 770 502",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Sigma Sports",
   "X": -0.3135497,
   "Y": 51.4126661,
   "Website": "https://www.sigmasports.com/",
   "Address": "St Johns Place, 37-43 High St, Hampton Wick, Kingston upon Thames KT1 4DA",
   "Phone": "03330 068 833",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "ONITsports",
   "X": -3.7015272,
   "Y": 51.4801429,
   "Website": "http://www.onitsports.co.uk/",
   "Address": "4 Eastern Promenade, Porthcawl CF36 5TS",
   "Phone": "01656 857 202",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Momentum Cycles",
   "X": 0.2949179,
   "Y": 51.6192297,
   "Website": "http://www.momentum-cycles.co.uk/",
   "Address": "149C High St, Brentwood CM14 4SA",
   "Phone": "01277 201 116",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Adrian's Bike Shop Freshwater",
   "X": -1.5193457,
   "Y": 50.6826144,
   "Website": "http://www.adriansbikeshop.com/",
   "Address": "The Coach House, 131a School Green Rd, Freshwater PO40 9BB",
   "Phone": "01983 755 007",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "In-Gear Cycle Sport",
   "X": 0.0317381,
   "Y": 51.0994291,
   "Website": "http://ingearcycles.co.uk/",
   "Address": "Lower Square, Lewes Rd, Forest Row RH18 5HD",
   "Phone": "01342 823 829",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Ian Browns Cycleshop",
   "X": -2.5364991,
   "Y": 49.4693613,
   "Website": "http://www.ianbrowns.co.uk/",
   "Address": "Les Banques, Guernsey GY1 2HZ, Guernsey",
   "Phone": "01481 721 581",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Pedal Power",
   "X": -2.1118177,
   "Y": 49.1865892,
   "Website": "http://www.pedalpowerjsy.com/",
   "Address": "36 The Parade, St Helier, Jersey JE2 3QQ, Jersey",
   "Phone": "01534 739 385",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 },
 {
   "Name": "Louth Cycle Center",
   "X": -0.002108,
   "Y": 53.3717861,
   "Website": "http://www.louthcyclecentre.co.uk/",
   "Address": "Unit 10-11, Station Estate, Newbridge Hill, Louth LN11 0JT",
   "Phone": "01507607447",
   "OfficialDemo": false,
   "SCB": true,
   "Juliana": false,
   "Reserve": true,
   "SweetProtection": false,
   "Cervelo": false,
   "CerveloDirt": false
 },
  {
   "Name": "Lovelo",
   "X": -0.5647327,
   "Y": 51.7599307,
   "Website": "http://www.lovelocycleworks.co.uk/",
   "Address": "Unit 7 Dwight's Yard, r/o, 167 High St, Berkhamsted HP4 3HB",
   "Phone": "01442873000",
   "OfficialDemo": false,
   "SCB": false,
   "Juliana": false,
   "Reserve": false,
   "SweetProtection": false,
   "Cervelo": true,
   "CerveloDirt": false
 }
]